<template lang="pug">
  v-container.pa-4(fluid grid-list-md)
    v-layout(wrap)
      //- v-flex(xs12)
      //-   h1.display.mb-1 Dashboard
      //- v-flex(xs12 md8)
      //-   v-layout(wrap)
      //-     v-flex
      //-       .d-flex.ai-center.jc-center
      //-         .display-1.mb-2.font-weight-700 ¡Hola {{nombre}}!
      v-flex(xs12 md4)
        v-layout(wrap)
          v-flex(v-for="(t, index) in openTickets" xs6, :key="index")
            v-card.elevation-1(height='100%').text-xs-center
              v-card-text
                .d-flex.ai-center.jc-center
                  .display-1.mb-2.font-weight-700 {{ abiertos[t.key] }}
                span.font-size-13 {{ t.label }}
                //- span.font-size-13 {{ t.label }}
  //- .container.d-flex.jc-center.ai-center
  //-   p.is-size-2 Bienvenido al Help Desk de la empresa {{empresa_full}}
    //- article.message.is-info.margin-top-10
    //-   .message-body
    //-     | Visualizar lista de tickets
    //-     router-link(to="/ticket") aquí
</template>

<script>
import Router from '../router/dispatcher.js'
export default {
  name: 'View_welcome_dispatcher',
  data () {
    return {
      empresa     : process.env.EMPRESA,
      empresa_full: process.env.EMPRESA_FULL,
      nombre      : localStorage.getItem('nombre'),
      openTickets : [
        {
          number: 0,
          label : 'Tickets abiertos',
          key   : 'all_usuario_o_cliente'
        }
      ]
    }
  },
  computed : {
    abiertos () {
      var vm = this
      return vm.$store.state.ticket.abiertos
    }
  },
  methods: {
    goTo (page) {
      Router.push(page)
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>




// WEBPACK FOOTER //
// View_welcome_customer.vue?fc92833e